import React from 'react';
import { Types } from '@wheeebo/polaris-api';
import RotationForm from './RotationForm';
function RotateGimbalGlobalForm({ onSubmit }) {
    return (React.createElement(RotationForm, { message: "Specify the absolute rotation of the gimbal.", onSubmit: (props) => onSubmit(Types.VehicleCommandRotateGimbalGlobal, props) }));
}
export default React.memo(RotateGimbalGlobalForm);
